<script lang="ts" setup>
</script>

<template>
  <li class="flex items-center gap-3">
    <Icon name="CheckCircle" />
    <span>
      <slot />
    </span>
  </li>
</template>
